export default {"src":"/_next/static/media/tablet-moderate.9bd3c8b6.svg","height":75,"width":80};